<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  <div
    class="outer"
  >
    <div
      class="content devices"
    >
      <h3>
        Point Discovery
        <motn-pill color="indigo">BACnet/IP</motn-pill>
      </h3>

      @if (!getCurrentSelectedDevice()) {
        <div
          class="fake-select error"
          (click)="onDeviceMenuClick()"
        >
          &nbsp;
        </div>
      }

      @if (getCurrentSelectedDevice()) {
        <div
          class="fake-select"
          (click)="onDeviceMenuClick()"
          [innerText]="$safeNavigationMigration(getCurrentSelectedDevice()?.Name)"
        ></div>
      }

      @if (deviceMenuOptions) {
        <motn-popover-multi-select
          [multiOrSingle]="'single'"
          [optionGroup]="deviceMenuOptions"
          (clickedOutsideMenu$)="onDeviceMenuDone()"
          (clickedOption$)="onDeviceMenuDone(); onDeviceChange();"
        ></motn-popover-multi-select>
      }

      <div class="label">
        Device
        <span
          (click)="infoDevicesMenu()"
        >
          <i class="fa-regular fa-circle-info"></i>
        </span>
      </div>

      @if (!selectionMode) {
        <motn-multichoice-horizontal
          [options]="timeoutOptions"
          (selectedItem$)="updateTimeout($event)"
        ></motn-multichoice-horizontal>
        <div class="label">
          Timeout
          <span
            (click)="infoDialog(INFO_TIMEOUT)"
          >
                <i class="fa-regular fa-circle-info"></i>
              </span>
        </div>
      }

      <div class="buttons">
        <button
          type="button"
          [ngClass]="{'loading': discovering}"
          (click)="startDiscovery()"
        >
          <span>Start Discovery</span>
          <motn-spinner></motn-spinner>
        </button>

        <button
          type="button"
          [ngClass]="{'red': discovering, 'alt': !discovering}"
          (click)="stopDiscovery()"
        >
          <span>Abort</span>
        </button>

        <label class="warning">
          <i class="far fa-exclamation-triangle"></i> Point discovery can temporarily interrupt BACnet traffic.
          <span
            (click)='infoDialog(INFO_INTERRUPTIONS)'
            style="text-decoration: underline"
          >More info</span>
        </label>
      </div>
    </div>

    @if (useCase) {
      <div
        class="content use-case"
      >
        <div class="subtitle">
          Discover points<br>to create tiles for
        </div>

        <div class="title">
          {{useCase}}
        </div>
      </div>
    }
  </div>

  <div
    class="outer"
  >
    @if (points.length > 0) {
      <div
        class="content results"
      >
        <h3>
          <div class="text">
            Points Found

            <motn-pill>{{filteredPoints.length}}</motn-pill>

            @if (formatRestriction) {
              <motn-pill>Showing {{formatRestriction}}-compatible points only</motn-pill>
            }

            <div class="actions">
              @if (!isMobile() && !selectionMode) {
                <motn-menu-button
                  buttonClass="small"
                  [optionsFactory]="createToolsOptions"
                >
                  Tools
                  <i class="fa-regular fa-chevron-down"></i>
                </motn-menu-button>
              }
          </div>

            <div class="search">
              <input
                class="small"
                placeholder="Search within results..."
                [(ngModel)]="searchTerm"
                (ngModelChange)="filterAndRenderPoints()"
              >
            </div>
          </div>
        </h3>

        <motn-sort-table
          [table$]="table$"
        ></motn-sort-table>
      </div>
    }
  </div>
</motn-drawer-gap-from-top>

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="editingTile = null"
    (deleted$)="editingTile = null"
  ></motn-tile-editor>
}
